module.exports = __webpack_public_path__ + "img/game_main_pc_217_off.bb54998d.png";